import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { POSTREQUEST } from "../../helpers/ServiceRequest";

function InsertCatagory() {
  const [catName, setCatName] = useState("");
  const [current, setCurrent] = useState(1);
  const [catErr, setCatErr] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });
  const { user } = useAuth();

  let navigate = useNavigate();
  const addCategory = async (e) => {
    e.preventDefault();

    // Validate input fields
    if (catName === "") {
      setCatErr(true);
      return false;
    }
    let URL = process.env.REACT_APP_API_URL + "/create-category";

    let payload = { CategoryName: catName, Current: parseInt(current) };
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/categories");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    } else {
      setMessage(response?.error?.message || 'Failed to create Category !!');
      setMessageType('error');
    }
  };

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav style={{ ariaLabel: "breadcrumb" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/categories"
                    className="text-decoration-none text-primary"
                  >
                    Categories
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Add New Category
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">Add category</h1>
                  <p className="text-lite fs-15 mb-0">
                    Please enter details to add new category
                  </p>
                </div>
                <form onSubmit={addCategory}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Category Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (catErr ? " is-invalid" : "")
                          }
                          placeholder="Enter Category Name"
                          onChange={(e) => {
                            setCatErr(false);
                            setCatName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-25 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md "
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Add Category
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default InsertCatagory;
